<template>
    <form-steps-cmp
        class="_modal"
        :form-info="props.formInfo"
        :button="props.button"
        :id-event="props.idEvent"
    >
    </form-steps-cmp>
</template>

<script>
    import {mapActions} from "vuex";
    import formSteps from "@components/base/form-steps.vue";

    export default {
        name: "feedback",
        props: ['props'],
        data() {
            return {
                infoForm: {
                    action: "feedback/send",
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
            }
        },
        watch: {
            'infoForm.success': function() {
                if (this.infoForm.success) {
                    this.modalClose();
                    this.modalType_successOpen({
                        title: this.$root.staticText.modal.successTitleFeedback,
                        text: this.$root.staticText.modal.successTextFeedback,
                        class: '_small'
                    });
                }

            },
            'infoForm.error': function() {
                if (this.infoForm.error) {
                    this.modalClose();
                    this.modalType_errorOpen({
                        title: this.$root.staticText.modal.errorTitle,
                        text: this.$root.staticText.modal.errorText,
                        class: '_small'
                    });
                }
            }
        },
        components: {
            'form-steps-cmp': formSteps,
        },
        methods: {
            ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/regEvent.vue